<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense>
						<v-col cols="1">
							<v-text-field clearable dense label="员工号" outlined v-model="query.employeeNo"></v-text-field>
						</v-col>
						<v-col cols="2">
							<v-text-field clearable dense label="IP" outlined v-model="query.clientIp"></v-text-field>
						</v-col>
						<v-col cols="2">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="2">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="5">
							<v-btn @click="getLogList">查询</v-btn>
						</v-col>
					</v-row>
				</template>
				<template v-slot:item.actionContent="{item}">
					<v-card width="400" max-width="400">
						<v-card-actions>
							<v-btn color="orange lighten-2" text @click="clickShowDetail(item)">
								查看详情
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn icon @click="clickShowDetail(item)">
								<v-icon>{{ showItemId===item.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
							</v-btn>
						</v-card-actions>
						<v-expand-transition>
							<div v-show="showItemId === item.id">

								<v-card-text>
									{{item.actionContent}}
								</v-card-text>
							</div>
						</v-expand-transition>
					</v-card>



				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense>
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="8" offset="1" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>




	</v-card>
</template>

<script>
	import md5 from "js-md5"
	import utils from "../../../config/utils"
	export default {
		name: "staff-log-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				shopId:"",
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '日志列表',
						disabled: true
					},
				],
				showItemId: "",
				data: {
					total: 0,
					headers: [{
							text: '员工号',
							align: 'start',
							value: 'employeeNo',
							sortable: false,
							width:200
						},
						{
							text: '员工姓名',
							value: 'employeeName',
							sortable: false,
							width:200
						},
						{
							text: '日志类型',
							value: 'actionType',
							sortable: false,
							width:300
						},
						{
							text: '日志内容',
							value: 'actionContent',
							sortable: false
						},
						{
							text: 'IP地址',
							value: 'logIp',
							sortable: false,
							width:300
						},
						{
							text: '操作时间',
							value: 'createAt',
							sortable: false,
							width:300
						},
					],
					list: [],
				},
				search: "",
				query: {
					page: 1,
					size: 20,
					start: "",
					end: "",
					employeeNo: "",
					clientIp: ""
				},
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getLogList();

		},
		methods: {
			clickShowDetail(item) {
				if (this.showItemId === item.id) {
					this.showItemId = ""
				} else {
					this.showItemId = item.id
				}
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getLogList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getLogList();
			},
			getLogList() {
				const that = this;

				let url = `/sys/log/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.employeeNo) {
					url += "&employeeNo=" + this.query.employeeNo;
				}
				if (this.query.clientIp) {
					url += "&clientIp=" + this.query.clientIp;
				}


				this.axios.get(url).then(response => {
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style>
</style>

